"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMMDDYYYY = exports.toMMDD = exports.getDateDaysAgo = exports.formatActivityDate = exports.makeCompactDate = exports.formatDate3 = exports.formatDate2 = exports.formatDate = exports.formatAMPM = exports.prettyTime = exports.getNowWithin15Mins = exports.getTimeZoneOffset = exports.getTimeZoneName = exports.makeTimePicker = exports.timePickerParse = exports.TIMEZONE_PICKER = exports.TIME_PICKER = exports.MONTHS_SHORT = exports.MONTHS_LONG = exports.MONTHS = void 0;
exports.MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
exports.MONTHS_LONG = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
exports.MONTHS_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
exports.TIME_PICKER = [
    "12:00am",
    "12:15am",
    "12:30am",
    "12:45am",
    "1:00am",
    "1:15am",
    "1:30am",
    "1:45am",
    "2:00am",
    "2:15am",
    "2:30am",
    "2:45am",
    "3:00am",
    "3:15am",
    "3:30am",
    "3:45am",
    "4:00am",
    "4:15am",
    "4:30am",
    "4:45am",
    "5:00am",
    "5:15am",
    "5:30am",
    "5:45am",
    "6:00am",
    "6:15am",
    "6:30am",
    "6:45am",
    "7:00am",
    "7:15am",
    "7:30am",
    "7:45am",
    "8:00am",
    "8:15am",
    "8:30am",
    "8:45am",
    "9:00am",
    "9:15am",
    "9:30am",
    "9:45am",
    "10:00am",
    "10:15am",
    "10:30am",
    "10:45am",
    "11:00am",
    "11:15am",
    "11:30am",
    "11:45am",
    "12:00pm",
    "12:15pm",
    "12:30pm",
    "12:45pm",
    "1:00pm",
    "1:15pm",
    "1:30pm",
    "1:45pm",
    "2:00pm",
    "2:15pm",
    "2:30pm",
    "2:45pm",
    "3:00pm",
    "3:15pm",
    "3:30pm",
    "3:45pm",
    "4:00pm",
    "4:15pm",
    "4:30pm",
    "4:45pm",
    "5:00pm",
    "5:15pm",
    "5:30pm",
    "5:45pm",
    "6:00pm",
    "6:15pm",
    "6:30pm",
    "6:45pm",
    "7:00pm",
    "7:15pm",
    "7:30pm",
    "7:45pm",
    "8:00pm",
    "8:15pm",
    "8:30pm",
    "8:45pm",
    "9:00pm",
    "9:15pm",
    "9:30pm",
    "9:45pm",
    "10:00pm",
    "10:15pm",
    "10:30pm",
    "10:45pm",
    "11:00pm",
    "11:15pm",
    "11:30pm",
    "11:45pm",
];
const SHORT_DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
exports.TIMEZONE_PICKER = generateTimeZones();
function generateTimeZones() {
    let tz = [];
    tz.push("Niel");
}
const timePickerParse = (value) => {
    console.log("[timePickerParse] parsing: " + value);
    const pieces = value.split(":");
    const hours12 = Number(pieces[0]);
    const minutes = Number(pieces[1].substring(0, 2));
    const meridiem = pieces[1].substring(2);
    const hours24 = meridiem === "am" ? hours12 : hours12 + 12;
    return { hours12, hours24, minutes, meridiem };
};
exports.timePickerParse = timePickerParse;
const makeTimePicker = (date) => {
    const hours24 = date.getHours();
    const hours12 = hours24 > 11 ? hours24 - 12 : hours24;
    const meridiem = hours24 > 11 ? "pm" : "am";
    const minutes = date.getMinutes();
    return hours12 + ":" + (minutes === 0 ? "00" : minutes) + meridiem;
};
exports.makeTimePicker = makeTimePicker;
const getTimeZoneName = (date) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // console.log("[getTimeZoneName] timezone name: " + timeZone);
    return timeZone;
};
exports.getTimeZoneName = getTimeZoneName;
// returns minutes between local time and a date
const getTimeZoneOffset = (date) => {
    return date.getTimezoneOffset();
};
exports.getTimeZoneOffset = getTimeZoneOffset;
// get now but round down to nearest 15 mins (0, 15, 30, 45)
const getNowWithin15Mins = () => {
    const now = new Date();
    let mins = now.getMinutes() - (now.getMinutes() % 15);
    now.setMinutes(mins);
    return now;
};
exports.getNowWithin15Mins = getNowWithin15Mins;
const prettyTime = (scheduledAt) => {
    let timeString = "";
    let hours24 = scheduledAt.getHours();
    let hours12 = hours24 > 12 ? hours24 - 12 : hours24;
    timeString += hours24 < 10 ? "0" + hours12 : hours12;
    timeString +=
        ":" + (scheduledAt.getMinutes() === 0 ? "00" : scheduledAt.getMinutes());
    timeString += scheduledAt.getHours() > 12 ? " pm" : " am";
    return timeString;
};
exports.prettyTime = prettyTime;
const formatAMPM = (date, capitalized = true) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? (capitalized ? "PM" : "pm") : capitalized ? "AM" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? parseInt("0" + minutes) : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
};
exports.formatAMPM = formatAMPM;
function formatDate(date) {
    const months = exports.MONTHS_LONG;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedDate = `${month} ${day} • ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`;
    return formattedDate;
}
exports.formatDate = formatDate;
function formatDate2(date, includeTime = true) {
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dateText = isToday ? "Today" : `${month} ${day}`;
    const dayText = SHORT_DAY[date.getDay()];
    // const dayAndDate = isToday ? "Today" : `${dayText} • ${dateText}`;
    const dayAndDate = isToday ? "Today" : `${dayText}, ${dateText}`;
    const formattedDate = dayAndDate +
        (isToday || includeTime
            ? `, ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`
            : "");
    return formattedDate;
}
exports.formatDate2 = formatDate2;
// Mar 12, 2023
function formatDate3(date, includeTime = false) {
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const year = date.getFullYear();
    const ampm = hours >= 12 ? "PM" : "AM";
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dateText = (isToday ? "Today" : `${month} ${day}, ${year}`) +
        (isToday || includeTime
            ? `, ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`
            : "");
    return dateText;
}
exports.formatDate3 = formatDate3;
function formatHours(hours) {
    return hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
}
function formatMinutes(minutes) {
    return minutes < 10 ? `0${minutes}` : minutes.toString();
}
function makeCompactDate(date) {
    // Ensure date is a valid Date object
    if (!(date instanceof Date)) {
        return "00/00/0000";
    }
    // Get individual date components
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    // Concatenate components with slashes
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
}
exports.makeCompactDate = makeCompactDate;
function formatActivityDate(date) {
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dayText = SHORT_DAY[date.getDay()];
    const dateText = isToday ? "Today" : dayText;
    const formattedDate = dateText + ` • ${month} ${day}`;
    return formattedDate;
}
exports.formatActivityDate = formatActivityDate;
function getDateDaysAgo(daysAgo) {
    const currentDate = new Date();
    const pastDate = new Date(currentDate);
    pastDate.setDate(currentDate.getDate() - daysAgo);
    return pastDate;
}
exports.getDateDaysAgo = getDateDaysAgo;
function toMMDD(date) {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}`;
}
exports.toMMDD = toMMDD;
function toMMDDYYYY(date) {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
}
exports.toMMDDYYYY = toMMDDYYYY;
